import { MusicId } from "../../engine/musicId";

const MUSIC_ASSET_DIR = "/audio/music/";

export class MusicLoader {
	static getFileNameForMusicId(musicId: MusicId): string | null {
		switch (musicId) {
			case MusicId.WASTELAND:
				return "745855__3ag1e__ambient-double-bass-stacc-w-bass_edit.mp3";
			case MusicId.CAVES:
				return "787370__looplicator__120-bpm-industrial-ambient-loop-13297-wav.wav";
			case MusicId.ROBOT_BASE:
				return "661236__tenonic__toxic-leak.wav";
			case MusicId.BOSS_PLOW:
				return "795272__looplicator__100-bpm-industrial-drum-loop-13503-wav.wav";
			// Shares the plow boss track until a dedicated one is sourced.
			case MusicId.BOSS_BLACK_HOLE:
				return "795272__looplicator__100-bpm-industrial-drum-loop-13503-wav.wav";
			default:
				return null;
		}
	}

	static getUrlForMusicId(musicId: MusicId): string | null {
		const file = MusicLoader.getFileNameForMusicId(musicId);
		return file ? MUSIC_ASSET_DIR + file : null;
	}
}
